import AssessmentIcon from "@mui/icons-material/Assessment";
import SettingsIcon from "@mui/icons-material/Settings";
import { Menu, usePermissions } from "react-admin";

export function CustomMenu() {
  const { permissions } = usePermissions();
  const isAdmin = permissions === "admin";
  return (
    <Menu>
      {isAdmin && <Menu.DashboardItem />}
      <Menu.ResourceItems />
      {isAdmin && <Menu.Item to="/reports" primaryText="Отчёты" leftIcon={<AssessmentIcon />} />}
      {isAdmin && <Menu.Item to="/settings" primaryText="Настройки" leftIcon={<SettingsIcon />} />}
    </Menu>
  );
}
